<template>
  <div class="p-3 d-flex flex-column" :id="`message-${index}`">
    <div
      :class="['msg-entry p-2 rounded', {
        'align-self-start': sender === 0,
        'align-self-end': sender === 1
      }]">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['sender', 'index']
}
</script>

<style lang="scss" scoped>
.msg-entry {
  background-color: #F2F6F9;
  font-size: 14px;
  color: #2F3941;
}
</style>
